<template>
  <v-main class="background-stars">
    <v-container
      class="pa-0 align-start"
      fill-height
      fluid
      align-items-start
      v-bind:class="{
        bg: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <v-row class="pa-0 mt-16 mb-2">
        <v-spacer></v-spacer>
        <v-col cols="10" md="5">
          <v-card class="pa-9 rounded-xl" elevation="2">
            <div style="width: 100%" class="d-flex justify-center text-center">
              <img
                alt="Logo"
                width="180"
                class="rounded-0 text-center"
                :src="require('@/assets/svg/logo.svg')"
              />
            </div>
            <div style="width: 100%">
              <a v-if="roles" @click="$router.go(-1)">&larr; Back</a>
              <router-view></router-view>
            </div>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'PlainFormLayout',
  data() {
    return {
      roles: null,
    };
  },
  created() {
    this.roles = localStorage.getItem('roles');
  },
};
</script>
